import React, { useState } from 'react';
import ProfileSection from '../../components/ProfileSection/ProfileSection';
import styles from './FloorplanSection.module.css';
import { Carousel } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import { useIntl } from 'react-intl';
import { ASSET_SECTION_LABELS } from '../../constants';


export default function FloorplanSection({ floorplans }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({id});

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const images = floorplans;

  const toggleModal = (index) => {
    if (!floorplans.length) return;
    setImageIndex(index);
    setModalIsOpen(!modalIsOpen);
  }

  return (
    <ProfileSection section="Floorplan" display="Floorplans" label={ASSET_SECTION_LABELS["Floorplans"]}>
      {floorplans.length ? <Carousel interval={null} className={styles.floorplanContent}>
        {floorplans.map((floorplan, i) =>
          <Carousel.Item key={`floorplan${i}`} className={styles.floorplanItem}>
            <img src={floorplan} alt="..." onClick={() => toggleModal(i)} />
          </Carousel.Item>
        )}
      </Carousel>
        : <>{t('ProfileAssetSection.noData')}<div className='my-4 py-3'><hr /></div></>}

      {modalIsOpen && (
        <Lightbox
          mainSrc={images[imageIndex]}
          nextSrc={images[(imageIndex + 1) % images.length]}
          prevSrc={images[(imageIndex + images.length - 1) % images.length]}
          onCloseRequest={() => toggleModal(imageIndex)}
          onMovePrevRequest={() =>
            setImageIndex((imageIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setImageIndex((imageIndex + 1) % images.length)
          }
        />
      )}
    </ProfileSection>
  )
}
